export default [
	{
		path: '*',
		name: 'not-found',
		component: () => import(
			/* webpackChunkName: "login" */ './../views/Notfound.vue'
		)
	}
];